import { Logout, TrendingUp } from "@mui/icons-material";

export default function StatisticsCard({
	title = "",
	number = "",
	change = "",
}) {
	return (
		<div className="bg-gray-50 rounded-lg p-2 space-y-2">
			<div className="flex justify-between gap-2">
				<div>
					<h6 className="text-sm">{title}</h6>
					<h1 className="font-bold">{number}</h1>
				</div>
				<div className="">
					<div className="bg-orange-100 rounded-lg px-2 py-1">
						<Logout />
					</div>
				</div>
			</div>
			<div>
				{change && (
					<p className="text-sm space-x-1">
						<span className="bg-green-100 rounded-md px-2 py-1 space-x-1">
							<TrendingUp />
							<span>{change}%</span>
						</span>
						<span>from last week</span>
					</p>
				)}
			</div>
		</div>
	);
}
